import { WorkflowTemplateOptionFragment } from 'types/graphql'

import { useFieldContext } from 'src/hooks/use-app-form'

import WorkflowTemplateSelect from '../../Selects/WorkflowTemplateSelect'

type Props = {
  recordTemplateId: number
  label?: string
  isRequired?: boolean
}
const WorkflowTemplateSelectField = ({ recordTemplateId, label, isRequired }: Props) => {
  const field = useFieldContext<WorkflowTemplateOptionFragment | undefined>()
  const errorMessage = field.state.meta.errors.join(', ')
  return (
    <WorkflowTemplateSelect
      errorMessage={errorMessage}
      value={field.state.value}
      onValueChange={field.setValue}
      label={label}
      recordTemplateId={recordTemplateId}
      isRequired={isRequired}
      onBlur={field.handleBlur}
    />
  )
}

export default WorkflowTemplateSelectField
